<template>
<div class="orderdetails-main">
    <div class="details-title">审核资料</div>
    <div class="details-content">
        <div class="content-left">
            <div class="left-item">
                <span>您好，请您提交审核资料！</span>
                <!-- <span>{{details.receiverName}}</span> -->
            </div>
            <div class="left-item">
                <span>审核资料：</span>
                <div>
                    <van-uploader round type="primary" v-model="fileList" :before-delete="beforeDelete" multiple :after-read="afterRead" />
                </div>
            </div>
                
       

        </div>

    </div>
    <van-button block round type="primary" color="var(--theme-color-main)" @click="submit">提交</van-button>
</div>
</template>

<script>
import {
    addToExamineImages,
    uploadImg
} from "@/api/api";
export default {
    data() {
        return {
            fileList: [],
            uploadUrl: "/api/upload/fileUpload",
            imgUrllist: "",
            imgUrlll: {},
            imgUrl: ""
        };
    },

    methods: {
        async afterRead(file) {
            // 此时可以自行将文件上传至服务器
            var formData = new FormData();

            //可以通过append()方法来追加数据
            formData.append("file", file.file);
            // console.log(formData)
            const res = await uploadImg(formData);
            if (res.code == "0000") {
                let con = this.fileList[this.fileList.length - 1].file.name;
                this.$set(this.imgUrlll, con, res.data)
                //this.imgUrlll.con = this.imgUrl;
            }
            console.log(this.imgUrlll);
        },
        beforeDelete(file) {
            console.log(file);
            let con = file.file.name;
            this.$delete(this.imgUrlll, con);
            console.log(this.imgUrlll);
            return true;
        },
        async submit() {

            for (const key in this.imgUrlll) {
                this.imgUrl += this.imgUrlll[key] + ",";
            }
            this.imgUrl = this.imgUrl.substring(0, this.imgUrl.length - 1);
            console.log(this.imgUrl);
            //let fieldData = this.uploadData.fieldData; // 缓存，注意，fieldData不要与fileData看混
            if (this.fileList.length === 0) {
                this.$message({
                    message: '请先选择图片',
                    type: 'warning'
                })
                return
            }

            // let content = file.file;
            // let data = new FormData();
            // data.append('img', content);

            // const fileLists = this.fileList;

            // const imgurl = fileLists.map(item => item.content)
            // this.imgurl = this.imgbase64

            // var avalues = new Array(imgurl);
            // var color = avalues.toString();

            // console.log(color);

            let params = {
                buyerId: this.$cookies.get("memberId") || sessionStorage.getItem('memberId'),
                orderNo: this.$route.query.orderNo,
                examineImages: this.imgUrl,
                parentOrderNo: this.$route.query.parentOrderNo
            }

            const res = await addToExamineImages(params);
            if (res.code == "0000") {
                this.$toast("提交审核成功");
                this.$router.push({
                    path: '/order',
                });
            }
        }
    },

    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.orderdetails-main {
    // width: 100%;
    height: auto;
    padding: 20px;

    .details-title {
        width: 100%;
        color: #333;
        font-weight: bold;
        font-size: 30px;
        margin-bottom: 20px;

    }

    .details-content {
        min-height: 235px;
        display: flex;
        flex-direction: row;

        .content-left {
            flex: 1;
            // padding: 20px;
            // background-color: #fbfbfb;
            // border-right: 1px solid #e5e5e5;

            .left-item {
                display: flex;
                flex-direction: row;
                margin-bottom: 30px;

                span:first-child {
                    font-size: 13px;
                    // width: 65px;
                    line-height: 26px;
                }

                span:last-child {
                    flex: 1;
                    line-height: 26px;
                }
            }
        }

        .content-right {
            flex: 2;
            padding: 20px;
        }
    }
}
</style>
